export const EMAIL_TEMPLATES_SET_USER_FOLDERS = 'EMAIL_TEMPLATES_SET_USER_FOLDERS';
export const EMAIL_TEMPLATES_DELETE_USER_FOLDERS = 'EMAIL_TEMPLATES_DELETE_USER_FOLDERS';
export const EMAIL_TEMPLATES_SET_SHARED_FOLDERS = 'EMAIL_TEMPLATES_SET_SHARED_FOLDERS';
export const EMAIL_TEMPLATES_SET_SELECTED_FOLDER ='EMAIL_TEMPLATES_SET_SELECTED_FOLDER';
export const EMAIL_TEMPLATES_SET_EDIT_FOLDERS = 'EMAIL_TEMPLATES_SET_EDIT_FOLDERS';
export const EMAIL_TEMPLATES_SET_FOLDERS_ORDER = 'EMAIL_TEMPLATES_SET_FOLDERS_ORDER';
export const EMAIL_TEMPLATES_UPDATE_FOLDER_NAME = 'EMAIL_TEMPLATES_UPDATE_FOLDER_NAME';
export const EMAIL_TEMPLATES_CREATE_USER_FOLDERS = 'EMAIL_TEMPLATES_CREATE_USER_FOLDERS';
export const EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS = 'EMAIL_TEMPLATES_CREATE_EDIT_FOLDERS';
export const EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS = 'EMAIL_TEMPLATES_DELETE_EDIT_FOLDERS';
export const EMAIL_TEMPLATES_SET_DELETED_FOLDERS = 'EMAIL_TEMPLATES_SET_DELETED_FOLDERS';



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/folderFlow/actionType.js